import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EventsKey } from 'ol/events';
import { toLonLat } from 'ol/proj';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { NavaidModel } from 'src/app/models/navaid';
import { CoordinatesComponent } from 'src/app/popup/coordinates/coordinates.component';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { MapService } from 'src/app/services/map.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { NavaidFromMapService } from 'src/app/services/navaid-from-map.service';
import { NavaidsService } from 'src/app/services/navaids.service';
import { PointsService } from 'src/app/services/points.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { UiBlockService } from 'src/app/services/ui-block.service';
import { UtilsService } from 'src/app/services/utils.service';
import {unByKey} from 'ol/Observable';
import { TabsService } from 'src/app/services/tabsService';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { icaoccModel } from 'src/app/models/icaoccModel';
import { NavaidControlService } from 'src/app/services/navaid-control.service';

@Component({
  selector: 'app-create-navaid-from-map',
  templateUrl: './create-navaid-from-map.component.html',
  styleUrls: ['./create-navaid-from-map.component.scss'],
  standalone: false
})
export class CreateNavaidFromMapComponent implements OnInit {


  eventKey: EventsKey
  navaidController : NavaidFromMapService;
  public calculationsDone : boolean = false;
  constructor(
    navaidFromMapService : NavaidFromMapService,
    public utilsService : UtilsService,
    private popupService: BsModalService,
    private navaidService : NavaidsService,
    private toolsService : ToolsControlService,
    private pointsController : PointsService,
    private uiBlock: UiBlockService,
    private modalService : ModalControlService,
    private configurationService : ConfigurationService,
    public tabsService: TabsService,
    public menuController : MenuManagementService,
  ){
    this.navaidController = navaidFromMapService;
  }

  ngOnInit(): void {
    if(this.configurationService.currentConfiguration != undefined){
      this.navaidController.fillConfigInfo();
    }
  }

  cancelNavaid(): void {
    this.navaidController.active = !this.navaidController.active;
    this.toolsService.navigationOnTop = false;
    if(this.navaidController.navaidFromMapModel.onlyClickedPoint) {
      unByKey(this.eventKey);
    }

  }

  changeSingleLevel(): void {
    //this.navaidController.navaidFromMapModel.singleLevel = !this.navaidController.navaidFromMapModel.singleLevel;
    this.navaidController.fillConfigInfo();
  }

  calculateLastPosition() : void{
    this.calculateNavaid();
  }

  calculateOnCoordinates() : void{
    const bsModalRef : BsModalRef = this.popupService.show(CoordinatesComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
    bsModalRef.content.onClose.subscribe(result => {
      if(result){
        this.calculateNavaid();
      }
    });
  }


  calculateNavaid() : void{
    this.uiBlock.startBlock("Calculating...");
    this.navaidController.calculateNavaid();
    this.calculationsDone = true;
    this.uiBlock.stopBlock();
    //this.modalService.showMesssageModal("Calculation done", "The calculations finished successfully.")
  }

  async acceptNavaid() : Promise<void>{
    let navaid = new NavaidModel();
    navaid.navaidtype = "DME";
    navaid.cone= this.configurationService.currentConfiguration.calculation.coneOfSilenceDefa;
    navaid.latLonDms = this.navaidController.navaidFromMapModel.latLonDms;
    navaid.latitude = this.navaidController.navaidFromMapModel.latitude;
    navaid.longitude = this.navaidController.navaidFromMapModel.longitude;
    navaid.doc = this.navaidController.navaidFromMapModel.doc.toString();
    navaid.antheight = this.configurationService.currentConfiguration.facilityConfiguration.antenaMaxHeightFT;
    navaid.antheightMeters = this.utilsService.feetToMeters(navaid.antheight);
    navaid.notupdate = 'false';
    (await this.pointsController.getTerrainElevation(navaid.latitude, navaid.longitude)).subscribe(
      (data) => {
        navaid.elevationTerrainMeters = data;
        navaid.elevationTerrainFeet = this.pointsController.convertToFeet(data);

        navaid.elevationRelativeTerrainMeters = navaid.elevationTerrainMeters + navaid.antheightMeters;
        navaid.elevationRelativeTerrainFeet = navaid.elevationTerrainFeet + navaid.antheight;

      }
    );
      this.navaidService.initializeIcaoCodes( navaid.latitude, navaid.longitude);

      this.tabsService.openNewCreateNavaidFromMap(this.navaidService.getNavaidPayload(navaid));
     
  }

}
